export const de = {
  // Navigation
  nav: {
    parking: 'Parkplatz',
    prices: 'Preise',
    contact: 'Kontakt',
    faq: 'FAQ',
    directions: 'Anfahrt',
    book: 'Buchen',
    bookNow: 'Jetzt buchen',
    selectLanguage: 'Sprache w\u00e4hlen',
  },

  // Hero
  hero: {
    headline: 'Stressfreies Valet-Parken',
    headlineLine2: 'am Flughafen Frankfurt',
    subtitle: 'Ihr Auto auf unseren eigens angemieteten Parkpl\u00e4tzen \u2013 sicher,',
    subtitleLine2: 'versichert und direkt am Terminal \u00fcbergeben.',
    arrivalLabel: 'Wann reisen Sie an?',
    departureLabel: 'Wann reisen Sie ab?',
    bookingNote: 'Buchung ab 24h im Voraus m\u00f6glich',
    ctaButton: 'Jetzt Parkplatz buchen',
  },

  // How It Works Section
  howItWorks: {
    title: 'In 4 Schritten zum Terminal',
    subtitle: 'Unser Valet-Service ist auf maximale Effizienz und Komfort ausgelegt.',
    step1: {
      category: 'Buchung',
      title: 'Online buchen',
      description: 'Reservieren Sie Ihren Parkplatz bequem online. W\u00e4hlen Sie Ihre Reisezeiten und Zusatzoptionen.',
    },
    step2: {
      category: '\u00dcbergabe',
      title: '\u00dcbergabe am Terminal',
      description: 'Fahren Sie direkt zum Abflugterminal. Unser Mitarbeiter erwartet Sie bereits zur Fahrzeugannahme.',
    },
    step3: {
      category: 'Reise',
      title: 'Sicher geparkt',
      description: 'W\u00e4hrend Sie reisen, steht Ihr Auto sicher und versichert auf unseren gepflasterten Parkpl\u00e4tzen.',
    },
    step4: {
      category: 'R\u00fcckkehr',
      title: 'Direkte R\u00fcckgabe',
      description: 'Bei Ankunft steht Ihr Fahrzeug p\u00fcnktlich am Terminal f\u00fcr Sie bereit. Einfach einsteigen und losfahren.',
    },
  },

  // Awards Section
  awards: {
    title: 'Cleveres Parken f\u00fcr smarte Reisende',
    subtitle: 'Valetparking am Flughafen Frankfurt \u2013 Maximale Sicherheit, minimaler Preis.',
    savings: 'Ersparnis',
    priceAdvantage: 'Bis zu 50% Preisvorteil',
    cheaperThanTerminal: 'G\u00fcnstiger als direkt am Terminal parken.',
    terminalParking: 'Terminal Parken',
    excellentService: 'Ausgezeichneter Service',
    topRatings: 'Top-Bewertungen von echten Kunden.',
    stars: '4.9/5 Sterne',
    bestPriceGuarantee: 'Bestpreis-Garantie',
    startingFrom: 'Bereits ab',
    forUpTo8Days: 'f\u00fcr bis zu 8 Tage',
    calculatePrice: 'Jetzt Preis berechnen',
    professionalValet: 'Professionelles Valetparking',
    vehicleSafeHands: 'Ihr Fahrzeug ist bei uns in sicheren H\u00e4nden. Wir garantieren h\u00f6chste Sicherheitsstandards.',
    insuredByLaw: 'Versichert nach den gesetzlichen Bestimmungen',
    pavedParking: 'Gepflasterter Parkplatz',
    ownRentedSpaces: 'Eigens angemietete Parkpl\u00e4tze',
  },

  // Security Section
  security: {
    badge: 'Sicherheit & Service',
    title: 'Ihr Fahrzeug in sicheren H\u00e4nden',
    p1: 'Wenn Sie unseren Valet-Service in Anspruch nehmen m\u00f6chten, bieten wir Ihnen bequemen und sorgenfreien Komfort.',
    p2: 'Wir \u00fcbernehmen Ihr Fahrzeug direkt an',
    p2bold: 'Terminal 1 oder 2',
    p2rest: 'des Frankfurter Flughafens und parken es sicher auf unseren eigens angemieteten, gepflasterten Parkpl\u00e4tzen. Diese befinden sich etwa 9 km vom Flughafen entfernt.',
    p3: 'Mit dieser geringen Entfernung zum Flughafen Frankfurt k\u00f6nnen wir Ihnen einen schnellen und effizienten Service bieten, sodass Ihr Auto sicher geparkt ist, w\u00e4hrend Sie verreisen.',
    insuredByLaw: 'Versichert nach den gesetzlichen Bestimmungen',
    pavedParking: 'Gepflasterter Parkplatz',
    only9km: 'Nur 9km Distanz zum Terminal',
    distanceBadge: '9km zum Terminal',
    locationLabel: 'Der Standort',
    locationTitle: 'Sicherheitsgel\u00e4nde Hattersheim',
    locationDesc: 'Sicher geparkt auf unseren eigens angemieteten, gepflasterten Parkpl\u00e4tzen. Nur f\u00fcr Personal zug\u00e4nglich.',
    securityLabel: 'Sicherheit',
    securityTitle: 'Rundum abgesichert',
    securityDesc: 'Ihr Fahrzeug ist bei uns in sicheren H\u00e4nden auf unserem privaten, gepflasterten Parkplatz.',
    handoverLabel: 'Terminal \u00dcbergabe',
    handoverTitle: 'Direkt am Abflug',
    handoverDesc: 'Direkte \u00dcbernahme an Terminal 1 oder 2. Effizient und ohne Zeitverlust starten Sie entspannt in Ihre Reise.',
    terminal1Active: 'Terminal 1 Aktiv',
    terminal2Active: 'Terminal 2 Aktiv',
  },

  // Contact & Locations Section
  contactSection: {
    badge: 'Kontakt & Anfahrt',
    title: 'Wir sind f\u00fcr Sie da',
    subtitle: 'Ihr direkter Draht zu uns. Parkplatz, Valet-Service und Support \u2013 alles an einem Ort.',
    support: 'Support',
    customerService: 'Kundenservice',
    copied: 'Kopiert!',
    location: 'Standort',
    parkingAddress: 'Parkplatz Adresse',
    planRoute: 'Route planen',
    nowOpen: 'Jetzt ge\u00f6ffnet',
    closed: 'Geschlossen',
    openingHours: '\u00d6ffnungszeiten (Valet)',
    hours: '07:00 \u2013 17:00 Uhr',
    dailyOpen: 'T\u00e4glich ge\u00f6ffnet',
  },

  // FAQ Section
  faqSection: {
    badge: 'WISSENSWERTES',
    title: 'H\u00e4ufig gestellte Fragen',
    subtitle: 'Hier finden Sie Antworten zu Parkablauf, Sicherheit und Preisen.',
    stillQuestions: 'Noch Fragen?',
    weHelpGladly: 'Wir helfen gerne weiter.',
    notFound: 'Nicht gefunden, was Sie suchen? Unser Support-Team ist f\u00fcr Sie da.',
    contactUs: 'Kontakt aufnehmen',
    q1: 'Wo wird mein Auto geparkt?',
    a1: 'Auf unseren eigens angemieteten Parkpl\u00e4tzen in Hattersheim. Ihr Fahrzeug steht nicht auf \u00f6ffentlichen Stra\u00dfen, sondern auf einem gesicherten Privatgel\u00e4nde.',
    q2: 'Was passiert bei Nachtankunft?',
    a2: 'Au\u00dferhalb unserer Kernzeiten (07:00-17:00) f\u00e4llt ein Nachtzuschlag von 80 \u20ac an. Bitte planen Sie dies bei Ihrer Buchung ein und informieren Sie uns rechtzeitig \u00fcber Ihre Ankunftszeit.',
    q3: 'Wie funktioniert die \u00dcbergabe?',
    a3: 'Sie fahren direkt zum Terminal 1 oder 2. Unser Valet-Mitarbeiter erwartet Sie dort zur Fahrzeug\u00fcbernahme. Die genauen Details erhalten Sie mit Ihrer Buchungsbest\u00e4tigung.',
  },

  // Booking CTA Section
  bookingCTA: {
    badge: 'Jetzt starten',
    title: 'Buchen Sie Ihren Parkplatz',
    subtitle: 'W\u00e4hlen Sie Ihre Reisedaten und sichern Sie sich Ihren Stellplatz mit Valet-Service.',
    arrivalLabel: 'Wann reisen Sie an?',
    departureLabel: 'Wann reisen Sie ab?',
    bookingNote: 'Buchung ist erst ab 24 Stunden im Voraus m\u00f6glich',
    daysParking: '{days} Tag{plural} Parken',
    valetIncluded: 'Valet-Service inklusive',
    days1to8: '1-8 Tage: 99\u20ac',
    ctaButton: 'Jetzt Parkplatz buchen',
    freeCancellation: 'Kostenlose Stornierung',
    valetService: 'Valet-Service',
  },

  // Footer
  footer: {
    description: 'Stressfreies Valet-Parken am Flughafen Frankfurt. Sicher, versichert und direkt am Terminal.',
    service: 'Service',
    parking: 'Parkplatz',
    prices: 'Preise',
    directions: 'Anfahrt',
    cancelBooking: 'Buchung stornieren',
    company: 'Unternehmen',
    contact: 'Kontakt',
    faq: 'FAQ',
    home: 'Home',
    contactTitle: 'Kontakt',
    locationInfo: 'Hattersheim (Flughafen Frankfurt)',
    hours: 'Mo-So, 07:00 - 17:00',
    copyright: '\u00a9 {year} Park-Box Frankfurt. Alle Rechte vorbehalten.',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'AGB',
  },

  // Booking Page
  booking: {
    pageTitle: 'Parkplatz online buchen',
    pageSubtitle: 'Sichern Sie sich Ihren Stellplatz in wenigen Schritten.',
    step1Label: 'Reisedaten',
    step2Label: 'Flugdaten',
    step3Label: 'Fahrzeug',
    step4Label: 'Kontakt',
    step5Label: 'Extras',
    // Step 1
    travelDates: 'Reisedaten',
    arrivalLabel: 'Wann reisen Sie an?',
    departureLabel: 'Wann reisen Sie ab?',
    bookingNote24h: 'Buchung ist erst ab 24 Stunden im Voraus m\u00f6glich',
    travelPeriod: 'Reisezeitraum: {days} Tag{plural} ausgew\u00e4hlt',
    continueToFlightData: 'Weiter zu Flugdaten f\u00fcr Ihre Preis\u00fcbersicht',
    // Step 2
    flightData: 'Flugdaten',
    flightNumberOutbound: 'Flugnummer Hinflug',
    flightNumberReturn: 'Flugnummer R\u00fcckflug',
    optional: '(optional)',
    arrivalTimeLabel: 'Ankunftszeit am Flughafen *',
    departureTimeLabel: 'Landezeit R\u00fcckflug *',
    nightSurchargeApplied: 'Nachtzuschlag (+{amount}\u20ac) wird berechnet',
    bookingNotPossible: 'Buchung nicht m\u00f6glich',
    booking24hRule: 'Eine Buchung ist erst ab 24 Stunden im Voraus m\u00f6glich. Bitte w\u00e4hlen Sie einen sp\u00e4teren Termin.',
    flightDataInfo: 'Die Flugdaten helfen uns bei der Abholung und Planung. Die Zeiten beziehen sich auf die \u00dcbergabe/Abholung am Terminal.',
    nightSurchargeInfo: 'Nachtzuschlag-Information',
    noNightSurcharge: 'Kein Nachtzuschlag',
    nightSurchargeTime: 'Vor 07:00 oder nach 17:00 Uhr:',
    nightSurchargeAmount: '+{amount}\u20ac Nachtzuschlag',
    timeRange: '07:00 \u2013 17:00 Uhr:',
    // Step 3
    vehicleData: 'Fahrzeugdaten',
    vehicleBrand: 'Fahrzeugmarke *',
    vehicleModel: 'Modell *',
    licensePlate: 'Kennzeichen *',
    vehicleColor: 'Fahrzeugfarbe *',
    // Step 4
    contactData: 'Kontaktdaten',
    emailLanguageLabel: 'Sprache f\u00fcr E-Mail-Best\u00e4tigung',
    bookAs: 'Ich buche als *',
    privateCustomer: 'Privatkunde',
    privatePerson: 'Privatperson',
    businessCustomer: 'Firmenkunde',
    businessCompany: 'Unternehmen',
    companyName: 'Firmenname *',
    vatId: 'USt-IdNr.',
    salutation: 'Anrede *',
    pleaseSelect: 'Bitte w\u00e4hlen',
    mr: 'Herr',
    mrs: 'Frau',
    diverse: 'Divers',
    phone: 'Telefon / Mobilnummer *',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    streetAndNumber: 'Stra\u00dfe & Nr. *',
    zipCode: 'PLZ *',
    city: 'Ort *',
    email: 'E-Mail *',
    emailRepeat: 'E-Mail Wiederholung *',
    emailMismatch: 'E-Mail Adressen stimmen nicht \u00fcberein',
    dataSecure: 'Ihre Daten werden sicher \u00fcbertragen und nur zur Buchungsabwicklung verwendet.',
    // Step 5
    extras: 'Zusatzleistungen',
    flightClass: 'Flugklasse *',
    economy: 'Economy',
    businessFirstClass: 'Business / First Class',
    chargingService: 'E-Ladeservice',
    chargingDesc: 'Ladeservice f\u00fcr Ihr E-Auto (Stromkosten werden separat berechnet)',
    cancellationProtection: 'Stornierungsschutz',
    cancellationProtectionDesc: 'Auch innerhalb 24h vor Anreise kostenlos stornieren',
    luggage: 'Ihr Reisegep\u00e4ck',
    luggageNone: 'Nicht ben\u00f6tigt',
    luggageCheckin: 'Koffer zum Aufgeben',
    luggageHandOnly: 'Nur Handgep\u00e4ck',
    paymentMethod: 'Zahlungsart',
    paymentCash: 'Zahlung: Bar vor Ort',
    paymentCashDesc: 'Bezahlung erfolgt bei Fahrzeug\u00fcbergabe',
    paymentPaypal: 'Zahlung: PayPal',
    paymentPaypalDesc: 'Bezahlen Sie vorab per PayPal an unsere Adresse (+5 € Gebühr).',
    paypalFee: 'PayPal-Gebühr',
    paypalAddressLabel: 'PayPal-Adresse',
    paymentReferenceHint: 'Bitte nach der Buchung die Buchungsnummer als Verwendungszweck angeben.',
    bookingSummary: 'Ihre Buchungs\u00fcbersicht',
    arrival: 'Anreise',
    departure: 'Abreise',
    flightDataSection: 'Flugdaten',
    arrivalAtAirport: 'Ankunft am Flughafen',
    landingTimeReturn: 'Landezeit R\u00fcckflug',
    flight: 'Flug',
    vehicle: 'Fahrzeug',
    brand: 'Marke',
    model: 'Modell',
    color: 'Farbe',
    contactDataSection: 'Kontaktdaten',
    priceOverview: 'Preis\u00fcbersicht',
    parkingDays: 'Parkplatz ({days} {daysLabel})',
    day: 'Tag',
    days: 'Tage',
    nightSurchargeArrival: 'Nachtzuschlag PKW-Annahme',
    nightSurchargeDeparture: 'Nachtzuschlag PKW-R\u00fcckgabe',
    valetServiceIncl: 'Valet-Service',
    included: 'Inklusive',
    totalPrice: 'Gesamtpreis',
    cancellationConditions: 'Stornierungsbedingungen',
    moreThan24h: 'Mehr als 24h vor Anreise:',
    freeCancellation: 'Kostenlose Stornierung',
    within24h: 'Innerhalb 24h vor Anreise:',
    fee100: '100% Geb\u00fchr',
    withProtection: 'Mit Stornierungsschutz (+5\u20ac):',
    alwaysFree: 'Immer kostenlos',
    callImportant: 'Wichtig: 60 Minuten vor Ankunft anrufen!',
    remarks: 'Bemerkungen',
    remarksPlaceholder: 'Haben Sie besondere W\u00fcnsche oder Hinweise? z.B. Art des Sperrgep\u00e4cks, Kindersitze, etc.',
    other: 'Sonstiges',
    leaveKeys: 'Autoschl\u00fcssel w\u00e4hrend der Reise beim Parkplatz Anbieter hinterlegen',
    mandatoryValet: '(Pflicht f\u00fcr Valet-Service)',
    acceptTerms: 'Ich habe die',
    termsLink: 'AGB',
    and: 'und die',
    privacyLink: 'Datenschutzbestimmungen',
    acceptTermsEnd: 'gelesen und akzeptiere diese. *',
    pleaseAcceptTerms: 'Bitte akzeptieren Sie die AGB um fortzufahren.',
    back: 'Zur\u00fcck',
    next: 'Weiter',
    submitting: 'Buchung wird erstellt...',
    submitButton: 'Jetzt verbindlich buchen',
    submitError: 'Fehler beim Erstellen der Buchung',
    errorGeneric: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    errorCreateBooking: 'Buchung konnte nicht erstellt werden',
    sslEncrypted: 'SSL Verschl\u00fcsselt',
    customerServiceBadge: 'Kundenservice',
  },

  // Confirmation Page
  confirmation: {
    bookingSuccess: 'Buchung erfolgreich!',
    thankYou: 'Vielen Dank f\u00fcr Ihre Buchung bei Park-Box Frankfurt',
    bookingNumber: 'Ihre Buchungsnummer',
    callImportant: 'Wichtig: 60 Minuten vorher anrufen!',
    callDesc: 'Bitte melden Sie sich sp\u00e4testens 60 Minuten vor Ankunft am Flughafen telefonisch bei uns.',
    confirmationSent: 'Best\u00e4tigung gesendet',
    emailSentTo: 'Eine E-Mail wurde an',
    emailSentEnd: 'gesendet.',
    travelDates: 'Reisedaten',
    arrival: 'Anreise',
    departure: 'Abreise',
    vehicle: 'Fahrzeug',
    type: 'Typ',
    licensePlate: 'Kennzeichen',
    color: 'Farbe',
    contactData: 'Kontaktdaten',
    priceOverview: 'Preis\u00fcbersicht',
    parkingDuration: 'Parkdauer',
    extras: 'Extras',
    nightSurchargeArrival: 'Nachtzuschlag Anreise',
    nightSurchargeDeparture: 'Nachtzuschlag Abreise',
    valetService: 'Valet-Service',
    included: 'Inklusive',
    totalPrice: 'Gesamtpreis',
    paymentMethod: 'Zahlungsart',
    paymentCash: 'Zahlung: Bar vor Ort',
    paymentPaypal: 'Zahlung: PayPal',
    paymentPaypalDesc: 'Bitte senden Sie den Gesamtbetrag per PayPal an diese Adresse.',
    paypalFee: 'PayPal-Gebühr',
    paymentReference: 'Verwendungszweck',
    nextSteps: 'So geht es weiter:',
    step1: '60 Minuten vor Ankunft am Flughafen rufen Sie uns an:',
    step2: 'Fahren Sie zum Flughafen Frankfurt, Terminal 1 oder 2.',
    step3: 'Treffpunkt: Bereich Abflug nach den Schranken.',
    step4: 'Bei Ihrer R\u00fcckkehr: Rufen Sie uns an, sobald Sie Ihr Gep\u00e4ck erhalten haben.',
    step5: 'R\u00fcckgabe im Bereich Abflug.',
    questionsContact: 'Bei Fragen erreichen Sie uns unter:',
    needToCancel: 'M\u00fcssen Sie stornieren?',
    cancelBooking: 'Buchung stornieren',
    print: 'Drucken',
    toHomepage: 'Zur Startseite',
    noBookingFound: 'Keine Buchung gefunden',
    noBookingDesc: 'Es wurden keine Buchungsdaten gefunden. M\u00f6glicherweise wurde die Seite direkt aufgerufen.',
    newBooking: 'Neue Buchung starten',
  },

  // Cancellation Page
  cancellation: {
    title: 'Buchung stornieren',
    subtitle: 'Geben Sie Ihre Buchungsdaten ein, um eine Stornierung anzufragen',
    bookingNumber: 'Buchungsnummer',
    emailAddress: 'Email-Adresse',
    emailPlaceholder: 'Ihre Email bei der Buchung',
    searchBooking: 'Buchung suchen',
    searching: 'Suche...',
    error: 'Fehler',
    pleaseEnterBoth: 'Bitte geben Sie Buchungsnummer und Email ein',
    alreadyCancelled: 'Bereits storniert',
    alreadyCancelledDesc: 'Diese Buchung wurde bereits storniert.',
    cancellationRequested: 'Stornierung bereits angefragt',
    cancellationRequestedDesc: 'Sie haben am {date} eine Stornierung angefragt. Wir melden uns bei Ihnen.',
    yourBooking: 'Ihre Buchung',
    arrival: 'Anreise',
    departure: 'Abreise',
    vehicle: 'Fahrzeug',
    totalPrice: 'Gesamtpreis',
    cancellationConditions: 'Stornierungsbedingungen',
    moreThan24h: 'Mehr als 24h vor Anreise:',
    freeCancellation: 'Kostenlose Stornierung',
    lessThan24hWith: 'Weniger als 24h MIT Stornierungsschutz:',
    lessThan24hWithout: 'Weniger als 24h OHNE Stornierungsschutz:',
    fee100: '100% Geb\u00fchr',
    freeCancellationMore24h: 'Kostenlose Stornierung m\u00f6glich (mehr als 24 Stunden vor Anreise)',
    freeCancellationProtection: 'Kostenlose Stornierung m\u00f6glich (Stornierungsschutz gebucht)',
    paidCancellation: 'Weniger als 24 Stunden vor Anreise, ohne Stornierungsschutz - 100% Geb\u00fchr',
    protectionIncluded: 'Stornierungsschutz ist in Ihrer Buchung enthalten',
    reasonLabel: 'Grund f\u00fcr Stornierung (optional)',
    reasonPlaceholder: 'z.B. Flug wurde annulliert',
    requestCancellation: 'Stornierung anfragen',
    cancelNowFree: 'Jetzt kostenlos stornieren',
    sendingRequest: 'Wird gesendet...',
    cancelling: 'Wird storniert...',
    afterSendNote: 'Nach Absenden pr\u00fcft unser Team Ihre Anfrage.',
    immediateNote: 'Die Stornierung wird sofort durchgef\u00fchrt.',
    questionsContact: 'Bei Fragen erreichen Sie uns unter:',
    orByEmail: 'oder per Email an info@parkboxfrankfurt.com',
    // Success states
    bookingCancelled: 'Buchung storniert!',
    cancelledSuccessfully: 'Ihre Buchung wurde erfolgreich storniert',
    freeCancellationDone: 'Kostenlose Stornierung',
    cancelledFreeDesc: 'Ihre Buchung wurde kostenfrei storniert. Sie erhalten eine Best\u00e4tigung per Email.',
    planNewTrip: 'Planen Sie eine neue Reise?',
    newBooking: 'Neue Buchung erstellen',
    toHomepage: 'Zur Startseite',
    requestSubmitted: 'Anfrage eingereicht',
    requestBeingProcessed: 'Ihre Stornierungsanfrage wird bearbeitet',
    importantNote: 'Wichtiger Hinweis',
    paidNoteDesc: 'Da Ihre Anreise innerhalb von 24 Stunden liegt und kein Stornierungsschutz gebucht wurde, kann laut unseren AGB eine Stornogeb\u00fchr anfallen.',
    whatHappensNext: 'Wie geht es weiter?',
    teamWillReview: 'Unser Team wird Ihre Anfrage pr\u00fcfen und sich zeitnah bei Ihnen melden.',
  },

  // Prices Page
  prices: {
    badge: 'Transparenz Garantie',
    title1: 'Einfache Preise.',
    title2: 'Keine Überraschungen.',
    subtitle: 'Premium Valet-Service ab 99€ für bis zu 8 Tage. Sicher, versichert und direkt am Terminal.',
    // Bento Cards
    valetInclusiveTitle: 'Valet Inklusive',
    valetInclusiveDesc: 'Fahrzeugübergabe direkt am Terminal. Kein Transfer nötig.',
    insuredTitle: 'Versichert',
    insuredDesc: 'Ihr Fahrzeug ist nach den gesetzlichen Bestimmungen versichert.',
    coreHoursLabel: 'Kernzeiten Valet-Service',
    coreHoursValue: '07:00 – 17:00 Uhr',
    nightRateNote: 'Außerhalb dieser Zeiten gilt unser Nachttarif (+80€).',
    // Calculator
    calcTitle: 'Berechnen Sie Ihre Kosten.',
    calcDesc: 'Unser Modell ist simpel. Sie zahlen pro Tag. Reisen Sie nachts an oder ab, fällt ein einmaliger Zuschlag an, um unser Personal fair zu bezahlen.',
    calcDays1to8: '1-8 Tage: <strong>99€</strong>',
    calcFrom9Days: 'Ab 9 Tagen: <strong>nach aktuellen Tagestarif</strong>',
    calcNightSurcharge: 'Nachtzuschlag (17:01 - 06:59): <strong>pauschal 80€</strong>',
    receiptLabel: 'Kostenvoranschlag',
    arrivalLabel: 'Anreise',
    departureLabel: 'Abreise',
    nightSurchargeWarning: 'Nachtzuschlag +80€',
    parkingDurationLabel: 'Parkdauer: ',
    daysSingular: 'Tag',
    daysPlural: 'Tage',
    parkingSlot: 'Parkplatz',
    valetServiceLine: 'Valet-Service',
    valetServiceFree: '0,00 € (Inklusive)',
    nightSurchargeArrival: 'Nachtzuschlag Anreise',
    nightSurchargeDeparture: 'Nachtzuschlag Abreise',
    totalLabel: 'Gesamt',
    bookNow: 'Jetzt buchen',
    // Addons
    addonsTitle: 'Zusatzleistungen',
    addonsSubtitle: 'Optional buchbar für maximalen Komfort.',
    addonEvTitle: 'E-Ladeservice',
    addonEvDesc: 'Ladeservice für Ihr Elektrofahrzeug. Stromkosten werden separat nach Verbrauch berechnet.',
    addonCancelTitle: 'Stornierungsschutz',
    addonCancelDesc: 'Volle Flexibilität. Kostenlose Stornierung oder Umbuchung bis zur letzten Minute vor Anreise.',
    // Price Comparison
    comparisonTitle: 'Warum mehr bezahlen?',
    comparisonDesc: 'Genießen Sie Valet-Luxus zum Preis eines klassischen Parkplatzes. Wir optimieren unsere Prozesse, um Ihnen den besten Preis am Markt zu bieten.',
    comparisonSaving: 'Sie sparen ~60% gegenüber Terminal-Parken',
    comparisonTerminal: 'Terminal',
    // FAQ
    faqTitle: 'Häufige Fragen zu Preisen',
    faqQ1: 'Wie berechnet sich die Parkdauer?',
    faqA1: 'Wir berechnen pro Kalendertag. Jeder angebrochene Tag wird als voller Tag gewertet. Dies garantiert Ihnen maximale Flexibilität bei leichten Verspätungen am Abreisetag.',
    faqQ2: 'Wann genau fällt der Nachtzuschlag an?',
    faqA2: 'Der Nachtzuschlag in Höhe von 80,00 € fällt pauschal an, wenn Ihre Fahrzeugübergabe (Anreise) oder Fahrzeugrückgabe (Abreise) in den Zeitraum zwischen 17:01 Uhr und 06:59 Uhr fällt.',
    faqQ3: 'Wie kann ich bezahlen?',
    faqA3: 'Die Bezahlung erfolgt wahlweise in bar bei der Fahrzeugübergabe oder vorab per PayPal an info@parkboxfrankfurt.com. Eine Online-Buchung im Voraus ist weiterhin erforderlich.',
    faqQ4: 'Sind Änderungen an der Buchung kostenlos?',
    faqA4: 'Mit unserem optionalen Stornierungsschutz (5,00 €) können Sie bis zur letzten Minute kostenlos stornieren oder umbuchen. Ohne diesen Schutz gelten unsere regulären Stornierungsbedingungen.',
  },

  // Parking Page (valet-parken)
  parkingPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbParking: 'Parkplatz & Standort',
    heroTitle: 'Sicherheit für Ihr Fahrzeug',
    heroSubtitle: 'Unsere eigens angemieteten Parkplätze in Hattersheim. Nur 10 km vom Terminal entfernt – inklusive Valet-Service.',
    // Section 1: Location
    locationBadge: 'Location & Sicherheit',
    locationTitle: 'Geschützt parken in Hattersheim',
    locationDesc: 'Keine Parkplatzsuche, keine engen Parkhäuser. Ihr Fahrzeug steht auf unseren eigens angemieteten Parkplätzen in der Südring 10. Beleuchtet und nur für unser Personal zugänglich.',
    locationFeature1: '10 km zum Flughafen (ca. 12 Min Fahrzeit für unser Team)',
    locationFeature2: 'Privates Gelände',
    locationFeature3: 'Asphaltierte & gepflasterte Flächen',
    locationImgAlt: 'Sicherer Parkplatz Hattersheim',
    // Section 2: Valet Process
    valetProcessTitle: 'So funktioniert der Valet-Service',
    valetProcessSubtitle: 'Einfach, schnell und komfortabel.',
    tabDeparture: 'Hinreise',
    tabReturn: 'Rückreise',
    // Departure steps
    depStep1Title: 'Buchung online abschließen',
    depStep1Desc: 'Reservieren Sie Ihren Stellplatz bequem über unsere Webseite. Sie erhalten sofort eine Bestätigung.',
    depStep2Title: 'Anfahrt zum Terminal',
    depStep2Desc: 'Fahren Sie direkt zum Abflugterminal 1 oder 2. Unser Mitarbeiter erwartet Sie bereits.',
    depStep3Title: 'Fahrzeugübergabe',
    depStep3Desc: 'Nach einem kurzen Check übergeben Sie den Schlüssel. Wir parken Ihr Auto sicher in Hattersheim.',
    // Return steps
    retStep1Title: 'Landung in Frankfurt',
    retStep1Desc: 'Willkommen zurück! Sobald Sie gelandet sind, schalten Sie bitte Ihr Handy ein.',
    retStep2Title: 'Kurzer Anruf',
    retStep2Desc: 'Rufen Sie uns an, sobald Sie Ihr Gepäck haben. Wir machen uns sofort auf den Weg.',
    retStep3Title: 'Rückgabe am Terminal',
    retStep3Desc: 'Ihr Auto wartet bereits am vereinbarten Ausgang auf Sie. Gute Heimfahrt!',
    valetImgAlt: 'Valet-Service Übergabe',
    // Section 3: Conditions
    conditionsTitle: 'Konditionen & Details',
    condPriceTitle: 'Ab 99€ für 8 Tage',
    condPriceDesc: 'Transparente Preisgestaltung ohne versteckte Kosten.',
    condPriceValetIncl: 'Valet-Service inklusive',
    condInsuredTitle: 'Versichert',
    condInsuredDesc: 'Ihr Fahrzeug ist nach den gesetzlichen Bestimmungen versichert.',
    condHoursTitle: '07:00 - 17:00 Uhr',
    condHoursDesc: 'Kernzeiten für Annahme & Rückgabe ohne Zuschlag.',
    condNightNote: 'Nachtzuschlag (17:01-06:59): 80€',
    // Section 4: Address & Contact
    addressTitle: 'Hier steht Ihr Fahrzeug',
    mapTitle: 'Park-Box Frankfurt Standort Karte',
    callUs: 'Rufen Sie uns an',
    writeUs: 'Schreiben Sie uns',
  },

  // Contact Page
  contactPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbContact: 'Kontakt',
    title: 'Wir sind f\u00fcr Sie da',
    subtitle: 'Haben Sie Fragen zu unserem Valet-Service oder Ihrem Parkplatz? Hier finden Sie alle Kontaktm\u00f6glichkeiten und unseren Standort in Hattersheim.',
    customerService: 'Kundenservice',
    customerServiceDesc: 'F\u00fcr R\u00fcckfragen zu bestehenden Buchungen oder allgemeine Informationen.',
    parkingAddress: 'Parkplatz-Adresse',
    parkingAddressDesc: 'Hier befindet sich unser gesichertes Gel\u00e4nde.',
    planRoute: 'Route planen',
    bookParking: 'Parkplatz buchen',
    bookParkingDesc: 'M\u00f6chten Sie einen Stellplatz reservieren?',
    bookParkingInfo: 'Bitte nutzen Sie f\u00fcr Parkplatzbuchungen unser Onlineformular.',
    goToBooking: 'Zur Buchung',
    yourWayToUs: 'Ihr Weg zu uns',
    yourWayToUsDesc: 'Unser Parkplatz in der S\u00fcdring 10, Hattersheim, ist strategisch g\u00fcnstig gelegen und bietet schnellen Zugang zum Terminal.',
    openOnGoogleMaps: 'Auf Google Maps \u00f6ffnen',
    faqTitle: 'Oft gestellte Fragen',
    faq1Question: 'Wo genau \u00fcbergebe ich mein Fahrzeug?',
    faq1Answer: 'Die \u00dcbergabe erfolgt direkt am Terminal 1 oder 2 des Frankfurter Flughafens. Genaue Informationen zum Treffpunkt und Ablauf erhalten Sie detailliert in Ihrer Buchungsbest\u00e4tigung.',
    faq2Question: 'Wie kurzfristig kann ich buchen?',
    faq2Answer: 'Sie k\u00f6nnen Ihren Parkplatz bis zu 24 Stunden vor Abflug bequem \u00fcber unser Online-Formular buchen. F\u00fcr kurzfristigere Anfragen kontaktieren Sie uns bitte telefonisch.',
    faq3Question: 'Was passiert, wenn mein Flug Versp\u00e4tung hat?',
    faq3Answer: 'Keine Sorge. Wir \u00fcberwachen die Flugzeiten. Bitte rufen Sie uns dennoch kurz unter der angegebenen Servicenummer an, sobald Sie gelandet sind, damit wir die R\u00fcckgabe Ihres Fahrzeugs optimal koordinieren k\u00f6nnen.',
  },

  // Anfahrt Page
  anfahrtPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbAnfahrt: 'Anfahrt',
    title: 'Anfahrt & Standort',
    subtitle: 'Ihr Weg zu unserem gesicherten Parkplatz in Hattersheim und Informationen zur Fahrzeug\u00fcbergabe am Flughafen Frankfurt.',
    ourLocation: 'Unser Standort',
    customerService: 'Kundenservice',
    customerServiceDesc: 'F\u00fcr R\u00fcckfragen zu bestehenden Buchungen oder allgemeine Informationen.',
    reachableDuringHours: 'Erreichbar in unseren \u00d6ffnungszeiten',
    planRouteGoogleMaps: 'Route auf Google Maps planen',
    openMap: 'Karte \u00f6ffnen',
    terminalHandoverTitle: 'Fahrzeug\u00fcbergabe am Terminal',
    terminalHandoverDesc: 'Wir \u00fcbernehmen Ihr Fahrzeug direkt am Abflugterminal. Bitte w\u00e4hlen Sie Ihr Terminal f\u00fcr detaillierte Anweisungen.',
    departureTerminal1: 'Abflug Terminal 1',
    terminal1Desc: 'Bitte fahren Sie direkt zur <strong>Abflugebene Terminal 1</strong>. Unser Valet-Fahrer erwartet Sie dort nach telefonischer Ank\u00fcndigung am vereinbarten Treffpunkt (meist T\u00fcr C).',
    navToTerminal1: 'Navigation zu Terminal 1',
    departureTerminal2: 'Abflug Terminal 2',
    terminal2Desc: 'F\u00fcr Fl\u00fcge ab Terminal 2 treffen wir uns direkt an der <strong>Vorfahrt des Terminals (Abflug/Departure)</strong>. Genaue Koordinaten und den Haltepunkt erhalten Sie bei Buchung.',
    navToTerminal2: 'Navigation zu Terminal 2',
    arrivalProcessTitle: 'So funktioniert die Anreise',
    arrivalProcessSubtitle: 'Einfacher Ablauf f\u00fcr einen stressfreien Start in den Urlaub.',
    step1Title: '30 Min vor Ankunft',
    step1Desc: 'Rufen Sie uns bitte 30 Minuten vor Ihrer Ankunft unter',
    step1DescEnd: 'an.',
    step2Title: 'Treffpunkt Terminal',
    step2Desc: 'Fahren Sie direkt zum vereinbarten Terminal (1 oder 2) am Flughafen Frankfurt. Keine Parkplatzsuche n\u00f6tig.',
    step3Title: 'Fahrzeug\u00fcbergabe',
    step3Desc: 'Unser Mitarbeiter (erkennbar an Park-Box Frankfurt Kleidung) nimmt Ihr Fahrzeug entgegen und f\u00fchrt einen kurzen Check durch.',
    step4Title: 'Sicheres Parken',
    step4Desc: 'Ihr Auto wird sicher auf unserem Gel\u00e4nde in der S\u00fcdring 10 geparkt, w\u00e4hrend Sie entspannt zum Check-in gehen.',
  },

  // FAQ Page
  faqPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbFaq: 'FAQ',
    title: 'Wie k\u00f6nnen wir helfen?',
    subtitle: 'Antworten zu Ablauf, Sicherheit und Preisen f\u00fcr Ihr Valet-Parken am Flughafen Frankfurt.',
    searchPlaceholder: "Suchen Sie nach 'Nachtzuschlag' oder 'Versicherung'...",
    noResults: 'Keine Ergebnisse f\u00fcr Ihre Suche gefunden.',
    categoryAll: 'Allgemein',
    categoryBookingPrices: 'Buchung & Preise',
    categorySecurity: 'Sicherheit',
    categoryProcess: 'Ablauf',
    faq1Question: 'Wie setzen sich die Parkgeb\u00fchren zusammen?',
    faq1Answer: 'Unsere Preise: 1-8 Tage kosten pauschal 99\u20ac. Ab 9 Tagen gilt der aktuelle Tagestarif. Bitte beachten Sie eventuelle Zuschl\u00e4ge f\u00fcr Nachtfahrten oder Zusatzservices, die transparent im Buchungsprozess angezeigt werden.',
    faq2Question: 'Wann f\u00e4llt der Nachtzuschlag an?',
    faq2Answer: 'Ein Nachtzuschlag von pauschal 80,00 \u20ac wird berechnet, wenn die Fahrzeug\u00fcbergabe oder -r\u00fcckgabe au\u00dferhalb unserer Kernzeiten (07:00 \u2013 17:00 Uhr) erfolgt. Dies deckt den personellen Mehraufwand in der Nacht ab.',
    faq3Question: 'Kann ich meine Buchung stornieren?',
    faq3Answer: 'Ja. Wenn Sie unseren Stornierungsschutz (5,00 \u20ac) gebucht haben, ist die Stornierung bis kurz vor Anreise kostenfrei m\u00f6glich. Andernfalls gelten unsere regul\u00e4ren AGB mit entsprechenden Stornierungsgeb\u00fchren.',
    faq4Question: 'Wie funktioniert die Fahrzeug\u00fcbergabe am Terminal?',
    faq4Answer: 'Sie fahren direkt zum vereinbarten Terminal am Flughafen Frankfurt. Unser Mitarbeiter (erkennbar an der Park-Box Frankfurt Kleidung) erwartet Sie, erstellt ein digitales \u00dcbergabeprotokoll und \u00fcbernimmt Ihr Fahrzeug. Sie k\u00f6nnen direkt zum Check-in gehen.',
    faq5Question: 'Wo genau wird mein Auto geparkt?',
    faq5Answer: 'Ihr Fahrzeug wird auf unseren eigens angemieteten Parkpl\u00e4tzen in der S\u00fcdring 10, Hattersheim geparkt. Es handelt sich um einen festen, gepflasterten Stellplatz auf Privatgel\u00e4nde, nicht um \u00f6ffentliches Stra\u00dfenland.',
    faq6Question: 'Ist mein Fahrzeug versichert?',
    faq6Answer: 'Selbstverst\u00e4ndlich. W\u00e4hrend der gesamten Obhut durch Park-Box Frankfurt ist Ihr Fahrzeug nach den gesetzlichen Bestimmungen versichert. Bei der \u00dcbergabe wird zudem der Zustand detailliert protokolliert, um Missverst\u00e4ndnisse auszuschlie\u00dfen.',
    securityBadge: 'Sicherheit',
    securityTitle: '24/7 \u00dcberwachung in Hattersheim',
    staffBadge: 'Personal',
    staffTitle: 'Geschulte Fahrer',
    moreThanParking: 'Mehr als nur Parken',
    moreThanParkingDesc: 'Entdecken Sie unsere Zusatzservices f\u00fcr maximalen Komfort.',
    serviceCharging: 'E-Laden',
    serviceInsured: 'Versichert',
    contactTitle: 'Nicht die passende Antwort gefunden?',
    contactDesc: 'Unser Team in Frankfurt steht Ihnen gerne pers\u00f6nlich zur Verf\u00fcgung. Wir antworten in der Regel innerhalb weniger Stunden.',
    writeEmail: 'E-Mail schreiben',
    callCustomerService: 'Kundenservice',
  },

  // AGB Page
  agbPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbAgb: 'AGB',
    title: 'Allgemeine Gesch\u00e4ftsbedingungen',
    disclaimer: 'F\u00fcr alle Links in unserem Internetauftritt gilt: Wir distanzieren uns ausdr\u00fccklich von den Inhalten und \u00fcbernehmen keine Haftung f\u00fcr die Inhalte der Seiten, auf die von unserer Website aus verwiesen wird.',
    section1Title: '\u00a7 1 Allgemeines',
    section1Text1: 'Alle von der Firma Parkboxfrankfurt.com angebotenen Leistungen unterliegen den nachfolgenden Allgemeinen Gesch\u00e4ftsbedingungen. Ma\u00dfgeblich ist die jeweils zum Zeitpunkt des Vertragsabschlusses g\u00fcltige Fassung. Mit der Buchung (Angebot), jedoch sp\u00e4testens mit Abschluss des Vertrages mit Park-Box-Frankfurt.com erkl\u00e4rt der Kunde sein Einverst\u00e4ndnis zu den AGB der Park-Box-Frankfurt.com, welche der Kunde im Internet kann. Abweichende Bestimmungen, auch insoweit sie in Allgemeinen Gesch\u00e4ftsbedingungen des Vertragspartners enthalten sind, finden keine Anwendung, es sei denn, sie werden von Park-Box-Frankfurt.com ausdr\u00fccklich schriftlich anerkannt.',
    section1Text2: 'Der Vertrag kommt zustande durch das Angebot des Kunden und der Best\u00e4tigung bzw. Annahme des Angebots durch Parkboxfrankfurt.com. Diese erfolgt in der Regel binnen 12 Stunden nach Reservierungsanfrage. Der Kunde ist verpflichtet, die Reservierungsbest\u00e4tigung unverz\u00fcglich auf Fehler oder sonstige M\u00e4ngel zu \u00fcberpr\u00fcfen und gegebenenfalls unrichtige Angaben der Parkboxfrankfurt.com unverz\u00fcglich mitzuteilen.',
    section1Text3: 'Ein Angebot durch den Kunden kann in den folgenden Weisen erfolgen: Buchungsanfragen unter der Homepage Parkboxfrankfurt.com, telefonische Anfrage oder per E-Mail.',
    section1Text4: 'Das Absenden der Buchung mit allen erforderlichen Daten an Parkboxfrankfurt.com stellt ein verbindliches Angebot zum Vertragsschluss dar. Hat ein Dritter die Buchung get\u00e4tigt, haftet er neben den eigentlichen Kunden als Gesamtschuldner f\u00fcr alle vertraglichen Pflichten des Kunden.',
    section1Text5: 'Die Anspr\u00fcche aus dem Vertragsverh\u00e4ltnis stehen ausschlie\u00dflich dem Kunden zu und sind nur mit Zustimmung der Firma Parkboxfrankfurt.com auf einem Dritten \u00fcbertragbar.',
    section2Title: '\u00a7 2 Geltungsbereich',
    section2Text1: 'Diese Allgemeinen Gesch\u00e4ftsbedingungen gelten f\u00fcr alle im Rahmen des Vertrages mit dem Parkboxfrankfurt.com gebotenen Leistungen, wie die Vermietung eines Stellplatzes f\u00fcr Kfz, sowie alle sonstigen Leistungen, die im Auftrag des Kunden f\u00fcr den Kunden erbracht werden.',
    section3Title: '\u00a7 3 Vertragsgegenstand',
    section3Text1: 'Parkboxfrankfurt.com ist verpflichtet, die von dem Kunden gebuchten Leistungen im Rahmen dieser AGB bereitzuhalten und die vereinbarten Leistungen zu erbringen. Der Vertragsgegenstand beinhaltet die Vermietung eines Stellplatzes f\u00fcr Kraftfahrzeuge zu den hier genannten Bedingungen und eventuellen sonstigen, schriftlich vereinbarten Zusatzleistungen.',
    section3Text2: 'Parkboxfrankfurt.com \u00fcbernimmt keine Obhut oder besonderen F\u00fcrsorgepflichten f\u00fcr die vom Mieter eingebrachten Gegenst\u00e4nde. Der Aufenthalt auf dem Betriebsgel\u00e4nde ist f\u00fcr Mieter nicht gestattet. Mit der Best\u00e4tigung der Reservierung erwirbt der Kunde das Recht, seinen Pkw im gebuchten Zeitraum auf einem Stellplatz auf dem Betriebsgel\u00e4nde abzustellen.',
    section3Text3: 'F\u00fcr bestehende Forderungen aus dem Mietvertrag hat die Firma Parkboxfrankfurt.com ein gesetzliches Pfandrecht am eingestellten Fahrzeug einschlie\u00dflich des entsprechenden Zubeh\u00f6rs. Die Firma Parkboxfrankfurt.com ist ebenfalls berechtigt, die eingestellten Fahrzeuge auf Kosten und Gefahr des entsprechenden Mieters vom Betriebsgel\u00e4nde entfernen zu lassen, wenn zum Beispiel:',
    section3List1: 'der Mietvertrag beendet und der Mieter nicht erreichbar ist',
    section3List2: 'ein eingestelltes Fahrzeug durch M\u00e4ngel eine allgemeine Gefahr darstellt (z. B. undichter Tank u.a.)',
    section3List3: 'ein eingestelltes Fahrzeug polizeilich nicht zugelassen ist oder w\u00e4hrend der Vertragsdauer durch die Beh\u00f6rden aus dem Verkehr gezogen wird',
    section3List4: 'das Fahrzeug unberechtigt abgestellt wurde',
    section3Text4: 'Der Mieter haftet f\u00fcr ein eingestelltes Fahrzeug bei \u00d6l- oder sonstigen Fl\u00fcssigkeitsverlusten und allen dadurch verursachten Verunreinigungen. Jeder Kunde und die von ihm beauftragten Personen haben sich so zu verhalten, dass Gef\u00e4hrdungen und Sch\u00e4digungen Dritter ausgeschlossen sind.',
    section3Text5: 'Im Falle der Besch\u00e4digung des Betriebsgel\u00e4ndes oder seiner Einrichtungen werden die entstandenen Kosten dem Kunden nach Beseitigung in Rechnung gestellt. In diesen F\u00e4llen hat der Kunde kein Recht zur Selbstvornahme.',
    section4Title: '\u00a7 4 Entgelt & Bezahlung',
    section4Text1: 'F\u00fcr die Preisberechnung gelten die aktuellen Preislisten zum Zeitpunkt des Vertragsabschlusses, die im Internet eingesehen werden k\u00f6nnen. Zeitangaben f\u00fcr Parkleistungen werden nach angebrochenen Kalendertagen ab dem Zeitpunkt der Einfahrt in den Parkbereich berechnet, wobei der Anreise- und der Abfahrtstag vom Betriebsgel\u00e4nde als ein ganzer Tag berechnet werden.',
    section4Text2: 'Die Firma Parkboxfrankfurt.com ist berechtigt, ohne vorherige Ank\u00fcndigung eine andere Aufschl\u00fcsselung oder Berechnung zu benutzen. Die Reservierungsbest\u00e4tigung beinhaltet das endg\u00fcltige Entgelt f\u00fcr die zugesagte Leistung, es sei denn, der Kunde \u00fcberzieht die Buchungszeit oder w\u00fcnscht zus\u00e4tzliche kostenpflichtige Leistungen, die zum Zeitpunkt der Best\u00e4tigung nicht bekannt waren.',
    section4Text3: 'Das Entgelt f\u00fcr den gebuchten Stellplatz und sonstige Leistungen wird im Voraus (\u00dcberweisung oder PayPal) oder sp\u00e4testens bei \u00dcbergabe in bar gezahlt. Bei elektronischer Zahlungsweise erteilt der Kunde im Falle einer nicht abbuchbaren Forderung seiner Bank die ausdr\u00fcckliche Erlaubnis, der Firma Parkboxfrankfurt.com oder einer von ihr beauftragten Person die Anschrift des Kunden und eventuelle weitere Informationen, die dem Ausgleich der Forderung dienlich sind, mitzuteilen.',
    section4Text4: 'Mit der elektronischen Zahlungsweise erkennt der Kunde die sich aus der Teilnahme am Abbuchungsverfahren geltenden Rechte und Pflichten mit seiner PIN, auch ohne seine Unterschrift, ausdr\u00fccklich an. Die Preise schlie\u00dfen die jeweilige gesetzliche Mehrwertsteuer mit ein.',
    section4Text5: 'Die Firma Parkboxfrankfurt.com kann die Herausgabe des eingestellten Fahrzeuges bis zur vollst\u00e4ndigen Bezahlung des Rechnungspreises verweigern.',
    section5Title: '\u00a7 5 R\u00fccktritt und Stornobedingungen',
    section5Text1: 'Park Box Frankfurt Inh. Dina Magdalena Havelka r\u00e4umt dem Kunden ein jederzeitiges R\u00fccktrittsrecht ein. Bei einem R\u00fccktritt von mindestens 24 Stunden vor angegebener Ankunftszeit auf dem Betriebsgel\u00e4nde fallen keine Stornokosten an. Bei einem R\u00fccktritt von weniger als 24 Stunden hat Park Box Frankfurt Inh. Dina Magdalena Havelka Anspruch auf eine angemessene Entsch\u00e4digung, die wahlweise eine konkret berechnete Entsch\u00e4digung oder eine R\u00fccktritts\u00adpauschale i. H. v. 50% des vereinbarten Preises beinhalten kann.',
    section5Text2: 'Ein beiderseitiger R\u00fccktritt aus wichtigem Grund bleibt hiervon unber\u00fchrt. Dieser liegt vor bei h\u00f6herer Gewalt, erheblicher Verm\u00f6gensverschlechterungen seit Vertragsschluss bzw. die Er\u00f6ffnung oder Beantragung eines Insolvenzverfahrens \u00fcber das Verm\u00f6gen einer der Vertragsparteien, sowie bei berechtigter Besorgnis seitens Park Box Frankfurt Inh. Dina Magdalena Havelka, die Inanspruchnahme der gebuchten Leistungen durch den Kunden werde die Betriebssicherheit oder das Ansehen des Unternehmens gef\u00e4hrden.',
    section5Text3: 'Die dieses K\u00fcndigungsrecht aus\u00fcbende Partei hat vor Aus\u00fcbung des K\u00fcndigungsrechtes aus wichtigem Grund die andere Partei hier\u00fcber unverz\u00fcglich schriftlich in Kenntnis zu setzen. Ein Anspruch auf Schadenersatz ist in diesen F\u00e4llen ausgeschlossen.',
    section5Text4: 'Der Parkplatzanbieter kann bis zu 24 Stunden vor dem Fahrzeug\u00fcbergabetermin aus wichtigen Gr\u00fcnden vom Vertrag zur\u00fccktreten. Wichtige Gr\u00fcnde sind z.B.: Systemfehler, \u00dcberbuchung durch Parkplatzvermittler oder beh\u00f6rdliche Anweisungen zur Untersagung der Stellplatznutzung.',
    section6Title: '\u00a7 6 Haftung / Haftungsausschluss / Betriebshaftversicherung',
    section6Text1: 'Die Firma Parkboxfrankfurt.com haftet f\u00fcr alle durch sie oder ihren Angestellten schuldhaft verursachten Sch\u00e4den auf Grund der gesetzlichen Haftungsbestimmungen (Vorsatz und grobe Fahrl\u00e4ssigkeit) durch seine Betriebshaftpflichtversicherung.',
    section6Text2: 'Bei leichter Fahrl\u00e4ssigkeit tritt eine Schadenshaftung nur dann ein, wenn diese auf Verletzung einer wesentlichen Vertragspflicht in einer den Vertragszweck gef\u00e4hrdende Weise zur\u00fcckzuf\u00fchren ist. In diesen F\u00e4llen ist die Haftung auf die vorhersehbaren, vertragstypischen Sch\u00e4den begrenzt.',
    section6Text3: 'Ebenso stellt der Kunde die Firma Parkboxfrankfurt.com frei bei Sch\u00e4den h\u00f6herer Gewalt (z.B. Sturmsch\u00e4den, Hagel, Blitzeinschl\u00e4ge, \u00dcberflutung usw.) sowie bei Sch\u00e4den durch innere und \u00e4u\u00dfere politische Unruhen, Kriegsereignisse und Vandalismus, Glassch\u00e4den die durch Steinschl\u00e4ge, Reifen & Felgensch\u00e4den durch Bordsteinkanten oder andere Gegenst\u00e4nde verursacht worden sind.',
    section6Text4: 'Ein Ersatzanspruch des Kunden auf Minderung oder Schadenersatz entf\u00e4llt dann, wenn dieser den Schaden zwecks Schadensfeststellung nicht unverz\u00fcglich und noch vor R\u00fcckgabe dem Aufsichtspersonal gemeldet hat.',
    section6Text5: 'Die Firma Parkboxfrankfurt.com haftet nicht f\u00fcr Besch\u00e4digung und Zerst\u00f6rung von Kraftfahrzeugen einschlie\u00dflich deren Inhalte und Ladungen, die durch Handlungen Dritter, z. B. durch andere Mieter oder sonstigen Personen oder Tieren, verursacht worden sind. Dies gilt auch f\u00fcr Entwendungen und Abhandenkommen von Kraftfahrzeugen, Fahrzeugteilen, Fahrzeuginhalt und Fahrzeugladung (z. B. Autoradio, Navigation, Autotelefon, pers\u00f6nliche Wertgegenst\u00e4nde, Computer, Fotoausr\u00fcstung, Sportausr\u00fcstung und \u00e4hnliches).',
    section6Text6: 'Besch\u00e4digungen sind dem Personal unverz\u00fcglich mitzuteilen. Die Rechtzeitigkeit der Ankunft ist nicht Vertragsgegenstand. Diese unterliegt den Obliegenheiten des Kunden. Schadenersatzanspr\u00fcche, insbesondere solche aus nicht erreichten Abfl\u00fcgen und sonstigen verpassten Terminen, sind ausgeschlossen. Ersatzanspr\u00fcche sind bei einer nicht Inanspruchnahme der gebuchten Leistungen auf Grund von versp\u00e4teter Anfahrt des Kunden ebenfalls ausgeschlossen.',
    section6Text7: 'Bei der angebotenen Dienstleistung \u201eHol- und Bring Service\u201c des Wagens von und zum Terminal ist das Kundenfahrzeug w\u00e4hrend der \u00dcberf\u00fchrungsfahrt zum/zur\u00fcck Parkplatz \u00fcber unsere Haftpflicht versichert.',
    section6Text8: 'Die Parkboxfrankfurt.com \u00fcbernimmt keine Haftung f\u00fcr evtl. Reifen & Felgensch\u00e4den, Glassch\u00e4den (Steinschlag), Zahnriemen, Motor,-Getriebesch\u00e4den oder sonstigen technischen Sch\u00e4den, die am Fahrzeug entstehen k\u00f6nnten oder Folgesch\u00e4den die aufgrund einer der vorgenannten Sch\u00e4den entstehen.',
    section6Text9: 'Die vorstehenden Haftungsbeschr\u00e4nkungen gelten f\u00fcr alle Schadenersatzanspr\u00fcche unabh\u00e4ngig von deren Rechtsgrund einschlie\u00dflich von Anspr\u00fcchen aus unerlaubter Handlung. Die vorstehenden Haftungsbeschr\u00e4nkungen gelten auch in F\u00e4llen etwaiger Schadenersatzanspr\u00fcche eines Kunden gegen Mitarbeiter oder Erf\u00fcllungsgehilfen von Parkboxfrankfurt.com.',
    section7Title: '\u00a7 7 Flugverschiebung & Umbuchung',
    section7Text1: 'Sollte sich Ihre Flugnummer oder sich das Datum des R\u00fcckfluges \u00e4ndern/verschieben, m\u00fcssen Sie sich selbst\u00e4ndig unter der angegebenen Rufnummer per SMS/WHATSAPP oder per E-Mail 24 Stunden vor dem eigentlichen R\u00fcckflug bei uns melden.',
    section7Text2: 'Der Parkplatzbetreiber beh\u00e4lt sich vor, eine Aufwandsentsch\u00e4digung in H\u00f6he von 35 EUR zu berechnen, falls er \u00fcber solch eine \u00c4nderung/Verschiebung nicht rechtzeitig informiert wird und sein Fahrer vergeblich am Flughafen wartet.',
    section7Important: 'Wichtig:',
    section7ImportantText: 'Kundenfahrzeuge werden in die Tiefgaragen vor die Terminals zur Selbstabholung verbracht, an denen unsere Kunden landen, wenn sie au\u00dferhalb unserer Gesch\u00e4ftszeiten (7:00 Uhr bis 17:00 Uhr) in Frankfurt am Main landen oder ihre Parkzeit bei uns abgelaufen ist!',
    section7OutsideHours: 'au\u00dferhalb unserer Gesch\u00e4ftszeiten',
    section7Text3: 'Abholinstruktionen bekommen unsere Kunden auf allen uns zur Verf\u00fcgung gestellten Kommunikationswegen (SMS/WhatsApp und E-Mail).',
    section8Title: '\u00a7 8 Datenschutz',
    section8Text1: 'Die zur Verf\u00fcgung gestellten Daten werden von der Firma Parkboxfrankfurt.com gem\u00e4\u00df Bundesdatenschutzgesetz gesch\u00fctzt. Der Kunde erkl\u00e4rt sich damit einverstanden, dass seine Daten von der Firma Parkboxfrankfurt.com im Rahmen der Vertragsbeziehung elektronisch verarbeitet und gespeichert werden. Die Daten werden nicht unbefugt an Dritte weitergegeben.',
    section8Text2: '\u00c4nderungen oder Erg\u00e4nzungen des Vertrages bed\u00fcrfen der Schriftform. M\u00fcndliche Zusagen oder einseitige \u00c4nderungen oder Erg\u00e4nzungen von einer der Vertragsparteien sind unwirksam. Falls sich eine oder mehrere Bestimmungen dieses Vertrages dem geltenden Recht zu Folge als ung\u00fcltig herausstellen sollten, wird die ung\u00fcltige Bestimmung durch eine g\u00fcltige, gesetzeskonforme Bestimmung derart ersetzt, die der Absicht der urspr\u00fcnglichen Bestimmung am n\u00e4chsten kommt. Die \u00fcbrigen Bestimmungen bleiben hiervon unber\u00fchrt. Dieser Vertrag unterliegt deutschem Recht. Gerichtsstand ist Frankfurt am Main.',
    companyLabel: 'Firma:',
    ownerLabel: 'Inh. Dina Magdalena Havelka',
    asOf: 'Stand 18.05.2022',
    validityNote: 'Mit dem Datum der Ausfertigung dieser Allgemeinen Gesch\u00e4ftsbedingungen verlieren alle zuvor verwendeten Allgemeinen Gesch\u00e4ftsbedingungen (AGB) f\u00fcr die Firma Parkboxfrankfurt.com ihre G\u00fcltigkeit.',
  },

  // Datenschutz Page
  datenschutzPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbDatenschutz: 'Datenschutz',
    title: 'Datenschutz',
    privacyTitle: 'Ihre Privatsph\u00e4re ist uns wichtig',
    privacyText: 'Wir verwenden keine Cookies oder sonstiges Tracking auf unserer Website.',
    description: 'Bei Park-Box Frankfurt legen wir gro\u00dfen Wert auf den Schutz Ihrer pers\u00f6nlichen Daten. Wir erheben nur die f\u00fcr die Buchung notwendigen Daten und geben diese nicht an Dritte weiter.',
  },

  // Impressum Page
  impressumPage: {
    breadcrumbHome: 'Startseite',
    breadcrumbImpressum: 'Impressum',
    title: 'Impressum',
    responsiblePerson: 'Inhaltlich Verantwortlicher (gem\u00e4\u00df \u00a7 10 Absatz 3 MDStV):',
    businessSeat: '(Gesch\u00e4ftssitz)',
    vatIdLabel: 'USt.ID.:',
    parkingAddressTitle: 'Parkplatz-Adresse',
    insuredValet: 'Versichertes Valetparking!',
  },

  // Common
  common: {
    day: 'Tag',
    days: 'Tage',
    clock: 'Uhr',
    from: 'ab',
    to: 'bis',
    yes: 'Ja',
    no: 'Nein',
    none: 'Keine',
    loading: 'Laden...',
    error: 'Fehler',
  },
} as const
